/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useEffect } from 'react';
import { ThemeProvider } from '@mui/styles';
import { Box, Typography } from '@mui/material';

import LoginForm from './loginForm/loginForm';
import { LightTheme, LuiLogo, Tokens } from '@jda/lui-common-component-library-mui5';

export const LandingScreen = () => {
  useEffect(() => {
    let mounted;
    const iframe = document.getElementById('mfe') as HTMLIFrameElement;
    if (iframe) {
      iframe.className = 'mfe';
    }
    return () => {
      mounted = false;
      return undefined;
    };
  }, []);

  return (
    <ThemeProvider theme={LightTheme}>
      <Box
        py={4}
        width="100%"
        height="100vh"
        style={{
          backgroundColor: '#F1F1F2',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'top',
          paddingTop: Tokens.spacing['$spacing-none'],
          backgroundAttachment: 'fixed',
          backgroundPosition: 'right center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          // backgroundImage: `url(${canUseWebP ? backgroundImageWEBP : backgroundImagePNG})`,
        }}
      >
        <Box flexDirection="column" flex="1" display="flex" justifyContent="center">
          <Box
            alignItems="center"
            width="100%"
            display="flex"
            justifyContent="center"
            style={{ paddingBottom: '20px' }}
          >
            <LuiLogo style={{ fontSize: '3.50rem' }} />
          </Box>
          <Box alignSelf="center" flexDirection="column" style={{ display: 'inherit' }}>
            <LoginForm />
          </Box>
        </Box>
        <Box
          data-testid="login-footer"
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Box
            data-testid="lui-portal-login-copyright"
            justifyContent="flex-end"
            alignItems="flex-end"
            flexGrow="1"
            display="flex"
          >
            <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center' }}>
              {''}
            </Typography>
          </Box>
          <Box data-testid="login-disclaimer" justifyContent="flex-end" alignItems="center" flexGrow="1" style={{width: '50%'}}>
            <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: '20px' }}>
              Copyright © 2025 Blue Yonder Group, Inc. ALL RIGHTS RESERVED.

The software is the confidential information of Blue Yonder Group, Inc., and is licensed as restricted rights software. The use, reproduction, or disclosure of this software is subject to restrictions set forth in your license agreement with Blue Yonder
              
            </Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default LandingScreen;
